import React from 'react';
import { motion } from 'framer-motion';
import codingIllustration from '../assets/images/coding-illustration.webp';

const Purpose = () => {
  return (
    <section id="purpose" className="pt-16 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#e6f0fa]/90 to-[#ffffff]/90 backdrop-blur-sm overflow-x-hidden">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="md:col-span-2 text-left max-w-3xl"
        >
          <h2
            className="text-3xl sm:text-4xl font-bold mb-8 leading-tight bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent"
          >
            用思考，打造未來
          </h2>
          <p className="mt-6 text-base sm:text-lg md:text-xl text-[#1e293b]">
            在演算法驅動的數位時代，學會「如何思考」遠比單純學習程式語言更重要。2026 APCS 模擬測驗團隊暑期營隊以運算思維為核心，結合邏輯推演與程式實作，帶領學員從問題分析到解決方案實現，培養思辨力與創造力，迎接未來挑戰。
          </p>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-[#1e293b]">
            我們相信，學習程式設計不僅是掌握語法，更是學會拆解問題、設計解法與驗證成果。營隊提供基礎、進階分班課程，讓每位學員都能找到最適合的學習路徑，從零開始或挑戰進階，逐步精進。
          </p>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-[#1e293b]">
            課程涵蓋變數、迴圈、遞迴、資料結構與圖論等核心主題，並透過「程式設計實作挑戰賽」檢驗學習成果。學員將在限時挑戰中解決跨領域問題，體驗真實的思維鍛鍊，並在講師講評中學習如何優化自己的思考與程式。
          </p>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-[#1e293b]">
            在陽明交通大學光復校區的夜晚，學員將參與程式趣味競賽與夜間團隊挑戰，在互動與挑戰中建立屬於未來創新人才的社群連結，激發創意與合作。
          </p>
          <p className="mt-6 text-base sm:text-lg md:text-xl text-[#93c5fd] font-semibold">
            「演算法不只是程式的靈魂，更是面對未知世界時的思考方式。」<br />
            加入 APCSS 運算思維實作培育營，讓我們從思考出發，寫出屬於未來的程式！
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="md:col-span-1 flex items-center justify-center"
        >
          <div className="w-[250px] h-[250px] sm:w-[300px] sm:h-[300px] bg-[rgba(96,165,250,0.15)] border-2 border-[#e0e7ff]/50 rounded-xl backdrop-blur-sm overflow-hidden shadow-md">
            <img
              src={codingIllustration}
              alt="Coding illustration"
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Purpose;
